import {IStrapiEntity, StrapiUtils} from "services/strapi";
import {ListItemsTable, ListItemsTableProps} from "components/common";
import {RoutesResolver} from "routes";
import {IFreightCarrier, TableSettings} from "features/freight-carriers";

interface Props extends Omit<ListItemsTableProps<
    IFreightCarrier & { id: number },
    void>,
    'settings' | 'data'> {

    data?: IStrapiEntity<IFreightCarrier>[]
}

export function FreightCarriersListTable({data, ...rest}: Props){
    const routesResolver = new RoutesResolver()
    return (
        <ListItemsTable
            {...rest}
            data={StrapiUtils.flattenStrapiEntities(data)}
            settings={TableSettings({
                routesResolver,
            })}
        />
    )
}